import React from 'react'
import clsx from 'clsx'
import LandingTabs from './tabs'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import { Animated } from 'react-animated-css'
import Typography from '@material-ui/core/Typography'
import ImageBannerDesktop from 'assets/illustrations/landing-banner-d.svg'
import ImageBannerMobile from 'assets/illustrations/landing-banner-m.svg'
import ImageFeature1 from 'assets/illustrations/landing-feature-followup.svg'
import ImageFeature2 from 'assets/illustrations/landing-feature-renovation.svg'
import ImageFeature3 from 'assets/illustrations/landing-feature-validation.svg'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'

const Landing = () => {
  const classes = useStyles()
  const t = useTranslation()
  return (
    <Box mb={3} py={8} className={classes.landing}>
      <Grid container spacing={4} className={classes.banner}>
        <Grid item xs={12} sm={6} lg={7}>
          <Box textAlign="center">
            <Hidden lgUp>
              <img
                style={{ maxWidth: '100%' }}
                src={ImageBannerMobile}
                alt="{t('landing:banner:title')}"
              />
            </Hidden>
            <Hidden mdDown>
              <img
                style={{ maxWidth: '100%' }}
                src={ImageBannerDesktop}
                alt="{t('landing:banner:title')}"
              />
            </Hidden>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} lg={5} className={classes.bannerSecondBlock}>
          <Animated animationIn="fadeInRight" animationInDuration={1000}>
            <Typography variant="h1" className={classes.bannerTitle}>
              {t('landing:banner:title')}
            </Typography>
          </Animated>
          <Animated
            animationIn="fadeInRight"
            animationInDuration={1000}
            animationInDelay={200}
          >
            <Typography variant="body1" className={classes.bannerSubtitle}>
              {t('landing:banner:subtitle')}
            </Typography>
          </Animated>
          <Animated
            animationIn="fadeInUp"
            animationInDuration={1000}
            animationInDelay={400}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.bannerButton}
              href={t('landing:banner:current_button_url')}
            >
              {t('landing:banner:current_button')}
            </Button>
          </Animated>
        </Grid>
      </Grid>
      <Container>
        <Grid container>
          <Grid item xs={12} md={4} className={classes.feature}>
            <img
              className={clsx(classes.featureImage)}
              src={ImageFeature1}
              alt={t('landing:feature1:heading')}
            />
            <Typography className={classes.featureTitle} variant="h2">
              {t('landing:feature1:heading')}
            </Typography>
            <Typography className={classes.featureText} variant="body1">
              {t('landing:feature1:text')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} className={classes.feature}>
            <img
              className={clsx(classes.featureImage)}
              src={ImageFeature2}
              alt={t('landing:feature2:heading')}
            />
            <Typography className={classes.featureTitle} variant="h2">
              {t('landing:feature2:heading')}
            </Typography>
            <Typography className={classes.featureText} variant="body1">
              {t('landing:feature2:text')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} className={classes.feature}>
            <img
              className={clsx(classes.featureImage)}
              src={ImageFeature3}
              alt={t('landing:feature3:heading')}
            />
            <Typography className={classes.featureTitle} variant="h2">
              {t('landing:feature3:heading')}
            </Typography>
            <Typography className={classes.featureText} variant="body1">
              {t('landing:feature3:text')}
            </Typography>
          </Grid>
        </Grid>
        <LandingTabs />
      </Container>
    </Box>
  )
}

export default Landing
